import { render, staticRenderFns } from "./AnnouncementTypesPage.vue?vue&type=template&id=40815582&scoped=true"
import script from "./AnnouncementTypesPage.vue?vue&type=script&lang=js"
export * from "./AnnouncementTypesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40815582",
  null
  
)

export default component.exports